<script>

/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
/* eslint-disable no-console */
import Swal from "sweetalert2";
import {
  urlMethods,
} from "@/state/helpers";
export default {
  name: 'print-cart',
    data() {
        return {
            loadingArr: [],
            breadcrumbData: [
                {text: "Trang chủ", to: { name: 'default' }},
                {text: "Đơn hàng",to: { name: 'order' }},
                {text: "Chi tiết",active: true}
            ],
            order: {
                id: 0
            }
        };
    },
    async created() {
        this.getOrder();
    },
    methods: {
        ...urlMethods,
        getDate: function() {
        return this.moment().format("DD/MM/YYYY HH:MM");
        },
        itemTotal: function(data) {
        return (data.cost - data.discount * data.cost / 100) * data.amount;
        },
        print: function() {
        let html = this.$refs.print_content.innerHTML;
        let printView = window.document.getElementById('printer-view');
        printView.innerHTML = html;
        window.print();
        },
        paymentName(text = ''){
            let arr = text.split('-');
            return arr[arr.length - 1].trim();
        },
        async getOrder(){
            this.order.id = this.$route.params.id;
            try {
                let res = await this.getUrl('order/'+this.order.id);
                if(typeof res.data == 'undefined' || !res.data || res.data == null || typeof res.data.id == 'undefined'){
                    throw 'Không thể lấy thông tin đơn hàng';
                }
                this.order = res.data;
                console.log(this.order);
                this.order.payments = JSON.parse(this.order.account_statements);
            } catch (error) {
                Swal.fire({icon: 'error',title: 'Lỗi...',text: error});
            }
        },
    },
    mounted: function () {
        setTimeout(() => {
            this.print();
        }, 500);
    },
    computed: {
        posName: function(){
            return ''
        },
    }
}
</script>
<template>
	<div class="receipt-print">
		<div class="print-content" ref="print_content">
            <div v-if="order.pos_config == 174">
                <div style="text-align: center"><img src="https://mia.vn/media/images/logo-herschel-2.jpg" alt="" style="height: 90px;"></div>
                <p style="text-align: center;padding: 5px 0px; font-size: 0.9em">https://mia.vn/herschel</p>
            </div>
            <div v-else>
                <h1 style="padding-top:0px; margin:0px; padding-bottom:0px; text-align:center; font-size:20px; font-weight: bold;text-transform: uppercase;">{{order.pos_name}}</h1>
                <p style="text-align:center;">www.mia.vn</p>
            </div>
            <p style="text-align:center; border-bottom: 1px dashed #000; padding-bottom: 10px;">{{order.address}}</p>
            <h1 style="padding-top:10px; margin:0px; padding-bottom:5px; text-align:center; font-size:20px; font-weight: bold;">PHIẾU THANH TOÁN</h1>
            <div class="flex-row">
                <div class="col-left">Thời gian:</div>
                <div class="col-right">{{moment(order.created_at).format("DD/MM/YYYY HH:MM")}}</div>
            </div>
            <div class="flex-row">
                <div class="col-left">Khách hàng:</div>
                <div class="col-right"><span><b>{{order.customer_name}}</b> - {{order.customer_phone}}</span></div>
            </div>
            <div class="flex-row">
                <div class="col-left">NVBH:</div>
                <div class="col-right">{{order.sale_man_name}}</div>
            </div>
            <div class="flex-row">
                <div class="col-left">Thu ngân:</div>
                <div class="col-right">{{order.user_name}}</div>
            </div>
            <ul style="padding:5px 0px; padding-left:10px; line-height:20px; border-top:2px solid #000; border-bottom:2px solid #000; margin:3px 0px 10px !important">
                <li style="margin-top:5px" v-for="item in order.products" :key="item.id" :value="item">{{item.product_name}}
                    <br/>1 x {{item.price_unit | VND}}₫ <span v-if="(item.discount > 0)"> - {{item.discount}}%</span> <span style="display:inline-block; float:right;font-weight:bold">= {{item.amount | VND}} <sup>₫</sup></span>
                </li>
                <li v-if="(order.voucher_discount != 0)">Giảm voucher: <span style="display:inline-block; float:right;font-weight:bold">-{{order.voucher_discount | VND}} <sup>₫</sup></span>
                </li>
                <li v-if="(order.other_discount != 0)">Giảm khác: <span style="display:inline-block; float:right;font-weight:bold">-{{order.other_discount | VND}} <sup>₫</sup></span>
                </li>
                <li v-if="(order.member_discount != 0)">Giảm thành viên: <span style="display:inline-block; float:right;font-weight:bold">-{{order.member_discount | VND}} <sup>₫</sup></span>
                </li>
                <li v-if="(order.feeship != 0)">Phí vận chuyển: <span style="display:inline-block; float:right;font-weight:bold">{{order.feeship | VND}} <sup>₫</sup></span>
                </li>
            </ul>
            <div class="flex-row bold-text">
                <div class="col-left">Thành tiền: </div>
                <div class="col-right"><span>{{order.amount_total | VND}} <sup>₫</sup></span></div>
            </div>            
            <div class="flex-row bold-text"><div class="col-left">Khách thanh toán:</div><div class="col-right"><span>{{order.amount_paid | VND}} <sup>₫</sup></span></div></div>
            <div style="padding-left: 15px;">
                <div class="flex-row" v-for="(item,index) in order.payments" :key="index" :value="item"><div class="col-left">{{paymentName(item.journal_name)}}:</div><div class="col-right"><span>{{item.amount | VND}} <sup>₫</sup></span></div></div>
            </div>
            <div class="flex-row bold-text" style="border-bottom: 2px solid #000;margin-bottom: 10px;padding-bottom: 10px"><div class="col-left">Tiền thừa: </div><div class="col-right"><span>{{order.amount_return | VND}} <sup>₫</sup></span></div></div>
            <p style="margin-bottom:3px">- Chỉ xuất hóa đơn đỏ trong ngày.</p>
            <p style="margin-bottom:3px">- Đổi hàng trong 365 ngày trên toàn hệ thống.</p>
            <p style="margin-bottom:3px">- Bảo hành theo số điện thoại cung cấp trên hóa đơn.</p>
            <p>
                <br/>Hỗ trợ sản phẩm và dịch vụ: <b style="font-size:18px">1800 6198</b>
            </p>
            <p style="text-align:center; font-style: italic; padding-top: 15px;margin-bottom: 0px !important;padding-bottom: 5px;">Xin cám ơn quý khách. Hẹn gặp lại!</p>
            <div class="text-center">---</div>
		</div>
	</div>
</template>